/* eslint max-len: 0 */
import React from 'react';
import { GComp, PathComp, SVGComp, TextComp, TextSComp } from '../SVGComp';

const NotFoundIcon = () => (
  <SVGComp width="308" height="107" viewBox="0 0 308 107" fill="none">
    <GComp fill="#000" fillRule="evenodd" opacity=".87">
      <TextComp fontFamily="Brown-Bold, Brown" fontSize="150" fontWeight="bold" transform="translate(-3)">
        <TextSComp x="0" y="107">
          4
        </TextSComp>
      </TextComp>
      <TextComp fontFamily="Brown-Bold, Brown" fontSize="150" fontWeight="bold" transform="translate(-3)">
        <TextSComp x="221" y="107">
          4
        </TextSComp>
      </TextComp>
      <GComp fillRule="nonzero">
        <PathComp
          d={`M204.533 80.237H100.888a2.08 2.08 0 0 1-2.08-2.074 53.9 53.9 0 0 1 53.887-53.925 2.074 2.074 0 0 1 0 4.148c-26.664.007-48.584 21.03-49.702 47.672h101.534a2.08 2.08 0 0 1 0 4.154l.006.025z`}
        />
        <PathComp
          d={`M204.533 80.856H100.888a2.7 2.7 0 0 1-2.7-2.693 54.525 54.525 0 0 1 54.507-54.544 2.693 2.693 0 1 1 0 5.386c-26.086 0-47.625 20.387-49.058 46.434h100.877a2.7 2.7 0 0 1 0 5.392l.019.025zm-51.838-55.999c-29.421.02-53.257 23.884-53.243 53.306a1.461 1.461 0 0 0 1.46 1.455h103.646a1.461 1.461 0 0 0 0-2.917H102.405v-.619c1.115-26.986 23.317-48.29 50.327-48.29a1.455 1.455 0 1 0 0-2.91l-.037-.025z`}
        />
        <PathComp
          d={`M204.533 80.237H100.888a2.08 2.08 0 1 1 0-4.155h101.534c-1.118-26.643-23.042-47.668-49.708-47.671a2.074 2.074 0 0 1 0-4.148 53.863 53.863 0 0 1 53.9 53.9 2.074 2.074 0 0 1-2.081 2.074z`}
        />
        <PathComp
          d={`M204.533 80.856H100.888a2.7 2.7 0 1 1 0-5.393h100.878c-1.433-26.044-22.969-46.43-49.052-46.433a2.693 2.693 0 1 1 0-5.386 54.513 54.513 0 0 1 54.518 54.519 2.693 2.693 0 0 1-2.699 2.693zM100.888 76.7a1.461 1.461 0 1 0 0 2.917h103.645c.804 0 1.455-.652 1.455-1.455a53.243 53.243 0 0 0-53.293-53.306 1.455 1.455 0 0 0 0 2.91c27.007.004 49.206 21.306 50.321 48.29v.62l-102.128.024z`}
        />
        <PathComp
          d={`M181.793 37.345c-.417 0-.824-.126-1.17-.36a49.46 49.46 0 0 0-27.928-8.574 2.074 2.074 0 0 1 0-4.148 53.633 53.633 0 0 1 30.262 9.287 2.074 2.074 0 0 1-1.164 3.795z`}
        />
        <PathComp
          d={`M181.793 37.964c-.54 0-1.069-.162-1.517-.465a48.835 48.835 0 0 0-27.575-8.469 2.693 2.693 0 1 1 0-5.386 54.259 54.259 0 0 1 30.609 9.398 2.65 2.65 0 0 1 1.127 1.721 2.693 2.693 0 0 1-2.644 3.2zm-29.098-13.107a1.455 1.455 0 0 0 0 2.91 50.148 50.148 0 0 1 28.275 8.668 1.486 1.486 0 0 0 2.018-.384 1.449 1.449 0 0 0-.39-2.024 53.014 53.014 0 0 0-29.903-9.17z`}
        />
        <PathComp d="M150.633 18.276h4.154v8.061h-4.154z" />
        <PathComp d="M155.407 26.956h-5.393v-9.287h5.393v9.287zm-4.155-1.238h2.916v-6.81h-2.916v6.81z" />
        <PathComp
          d={`M152.695 19.737a9.528 9.528 0 1 1 9.528-9.522 9.534 9.534 0 0 1-9.528 9.522zm0-14.896a5.374 5.374 0 1 0 0 10.748 5.374 5.374 0 0 0 0-10.748z`}
        />
        <PathComp
          d={`M152.695 20.356a10.147 10.147 0 1 1 10.147-10.14c-.007 5.6-4.547 10.137-10.147 10.14zm0-19.05a8.909 8.909 0 1 0 8.909 8.91c-.017-4.91-4-8.882-8.909-8.885v-.025zm0 14.902a5.993 5.993 0 1 1 5.993-5.993 6 6 0 0 1-5.993 5.975v.018zm0-10.747a4.755 4.755 0 1 0 4.755 4.754 4.761 4.761 0 0 0-4.755-4.754zM204.533 97.188H100.888a2.08 2.08 0 0 1-2.08-2.08v-8.816a2.08 2.08 0 0 1 2.08-2.08h103.645a2.074 2.074 0 0 1 2.074 2.08v8.816a2.074 2.074 0 0 1-2.074 2.08zm-101.571-4.154h99.497v-4.668h-99.497v4.668z`}
        />
        <PathComp
          d={`M204.533 97.807H100.888a2.706 2.706 0 0 1-2.7-2.7v-8.815a2.706 2.706 0 0 1 2.7-2.7h103.645a2.7 2.7 0 0 1 2.693 2.7v8.816a2.7 2.7 0 0 1-2.693 2.699zM100.888 84.806c-.807 0-1.461.654-1.461 1.46v8.817c0 .807.654 1.461 1.46 1.461h103.646a1.461 1.461 0 0 0 1.455-1.461v-8.816c0-.805-.65-1.458-1.455-1.461H100.888zm102.19 8.822H102.343v-5.906h100.735v5.906zm-99.497-1.238h98.259v-3.43H103.58v3.43z`}
        />
      </GComp>
    </GComp>
  </SVGComp>
);

export default NotFoundIcon;
